import { render, staticRenderFns } from "./evaluationing.vue?vue&type=template&id=24629f76&scoped=true"
import script from "./evaluationing.vue?vue&type=script&lang=ts"
export * from "./evaluationing.vue?vue&type=script&lang=ts"
import style0 from "./evaluationing.vue?vue&type=style&index=0&id=24629f76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24629f76",
  null
  
)

export default component.exports